/* FENDO - add-to-cart button feedback on the main product page.
   Adds .is-added to the stock add-to-cart button for a moment after the theme's "variant:add" event
   (the item is in the cart). The press and loading states are pure CSS (fendo-product-blocks.css). */
(() => {
  if (window.__fendoAtcFeedback) return;
  window.__fendoAtcFeedback = true;

  const SHOW_MS = 1500;
  let timer = 0;
  let current = null;

  const clear = () => {
    clearTimeout(timer);
    current?.classList.remove('is-added');
    current = null;
  };

  document.addEventListener('variant:add', (event) => {
    const form = event.target;
    if (!(form instanceof Element)) return;
    const button = form.querySelector('.buy-buttons--stock .button');
    if (!button) return;

    clear();
    current = button;
    button.classList.add('is-added');
    timer = setTimeout(clear, SHOW_MS);
  });

  // The theme re-renders the button on every variant change: drop the state with it.
  document.addEventListener('variant:change', clear);
})();
